/**
 * Resolve a bilingual `{ en, ar }` value (or a plain string) for the active
 * language. Shared by every crop-page component so the en/ar selection logic
 * lives in exactly one place.
 */
export const cropText = (value, lang) => {
  if (value && typeof value === "object" && ("en" in value || "ar" in value)) {
    return lang === "AR" ? value.ar : value.en;
  }
  return value;
};
